var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpointsDisabledS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7689 0.552196H5.23108C4.35222 0.552196 3.53845 1.02206 3.09831 1.78346L0.330105 6.57829C-0.110035 7.33969 -0.110035 8.27799 0.330105 9.04081L3.09831 13.8371C3.53845 14.5985 4.3508 15.0683 5.23108 15.0683H10.7689C11.6478 15.0683 12.4615 14.5985 12.9017 13.8371L15.6699 9.04081C16.11 8.27941 16.11 7.34111 15.6699 6.57829L12.9017 1.78204C12.4615 1.02064 11.6492 0.550781 10.7689 0.550781V0.552196Z",
    fill: "white",
    fillOpacity: 0.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93246 5.08154H11.0134V6.31447H6.78689V7.15969H10.3953V8.39261H6.78689V9.40067H11.0675V10.6336H4.93246V5.08154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpointsDisabledS);
export default __webpack_public_path__ + "static/media/epoints-disabled-S.b94fee9017ec6dd1394f2cd7f48603cf.svg";
export { ForwardRef as ReactComponent };